import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import React from 'react';

interface PetCardMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  // onSetPrimary: () => void;
  // onDuplicate: () => void;
  onDelete: () => void;
  // isPrimary?: boolean;
}

const PetCardMenu: React.FC<PetCardMenuProps> = ({
  anchorEl,
  open,
  onClose,
  // onSetPrimary,
  // onDuplicate,
  onDelete,
  // isPrimary,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={{
        '& .MuiPaper-root': {
          borderRadius: 2,
          minWidth: 200,
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
        },
      }}
    >
      {/* <MenuItem
        onClick={() => {
          onSetPrimary();
          onClose();
        }}
        disabled={isPrimary}
        sx={{
          py: 1.5,
          px: 2,
          "&:hover": {
            backgroundColor: "rgba(23, 139, 142, 0.08)",
          },
        }}
      >
        <ListItemIcon>
          <StarIcon fontSize="small" sx={{ color: isPrimary ? "#FDB833" : undefined }} />
        </ListItemIcon>
        <ListItemText>
          {isPrimary ? "Primary Pet" : "Set as Primary Pet"}
        </ListItemText>
      </MenuItem> */}
      {/* <MenuItem
        onClick={() => {
          onDuplicate();
          onClose();
        }}
        sx={{
          py: 1.5,
          px: 2,
          '&:hover': {
            backgroundColor: 'rgba(23, 139, 142, 0.08)',
          },
        }}
      >
        <ListItemIcon>
          <ContentCopyIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Duplicate Profile</ListItemText>
      </MenuItem> */}
      <MenuItem
        onClick={() => {
          onDelete();
          onClose();
        }}
        sx={{
          py: 1.5,
          px: 2,
          color: '#D32F2F',
          '&:hover': {
            backgroundColor: 'rgba(211, 47, 47, 0.08)',
          },
        }}
      >
        <ListItemIcon>
          <DeleteOutlineIcon fontSize="small" sx={{ color: '#D32F2F' }} />
        </ListItemIcon>
        <ListItemText>Delete Pet</ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default PetCardMenu;
